<script setup lang="ts">
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { MAX_TOOLTIP_LIST_LENGTH } from '@/constants';

const props = defineProps<{
  users: {
    id: number;
    name: string;
    to: RouteLocationRaw;
  }[];
  emptyText: string;
}>();

const tooltipContents = computed(() =>
  props.users.slice(0, MAX_TOOLTIP_LIST_LENGTH),
);

const otherUserCount = computed(
  () => props.users.length - MAX_TOOLTIP_LIST_LENGTH,
);
</script>

<template>
  <template v-if="tooltipContents.length === 0">
    {{ emptyText }}
  </template>
  <template v-else>
    <template v-for="user in tooltipContents" :key="user.id">
      <router-link :to="user.to"> ・{{ user.name }} </router-link>
      <br />
    </template>
    <p v-if="otherUserCount > 0">
      {{ `他${otherUserCount}名` }}
    </p>
  </template>
</template>
